import React from 'react';
import {LandingPageContent} from '@/constants';
import {Button} from '@/ui-kits';
import {Images} from '@/constants/defaults';

interface ExplanationProps {
  id?: string;
  openModal?: () => void;
}
export const Explanation: React.FC<ExplanationProps> = ({id, openModal}) => {
  return (
    <div id={id} className="flex flex-col items-center md:px-4 pt-10 md:pt-16 pb-4 md:pb-6">
      <div className="rounded-3xl flex relative flex-col items-center pt-4 w-full pb-40 max-w-[1440px] bg-gradient-to-r from-[#86BBF1] to-[#D2EAEF]">
        {/* Background Image */}

        {/* heading */}
        <h2 className="text-2xl sm:text-3xl md:text-4xl inline-flex gap-2 font-FigtreeBold text-white my-4 px-4 break-words">
          {LandingPageContent.explanation.title.map(item => (
            <p id={item.is_special ? 'gradient-text-2' : ''} key={item.text} className="break-words">
              {item.text}{' '}
            </p>
          ))}
        </h2>

        {/* description */}
        <p className="text-sm sm:text-base md:text-[18px] whitespace-normal lg:whitespace-pre-line font-FigtreeRegular text-black text-center px-4 break-words mb-4 sm:mb-6 md:mb-8">
          {LandingPageContent.explanation.description}
        </p>

        {/* cards */}
        <div className="flex flex-col sm:flex-row flex-wrap gap-4 sm:gap-6 md:gap-8 lg:gap-16 items-stretch p-4 sm:p-8 md:p-12 lg:p-16 justify-center">   
          {LandingPageContent.explanation.steps.map((item) => (
            <div
              className="flex flex-col flex-1 items-center gap-4 p-6 2xl:p-10 grow flex-shrink-0 min-w-0 w-full sm:w-auto sm:min-w-[200px] sm:max-w-[300px] rounded-3xl bg-white"
              key={item.title}>
              <img
                src={item.image}
                alt=""
                className="object-contain size-[60px]"
              />
              <h3 className="text-lg sm:text-xl font-headingSemiBold text-ui_blue text-center break-words">
                {item.title}
              </h3>
              <p className="text-xs sm:text-sm font-Body text-center opacity-60 break-words px-2">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* get started */}
      <div
        style={{boxShadow: '0px 0px 10px -4px #000000'}}
        className="flex flex-col items-center py-6 px-4 sm:px-6 md:px-10 lg:px-16 mx-2 sm:mx-4 -mt-28 sm:-mt-36 md:-mt-40 z-[2] bg-white rounded-3xl gap-4 w-[calc(100%-16px)] sm:w-[85%] md:max-w-[550px] md:w-full">
        <img
          src={Images.getStarted}
          alt=""
          className="size-12 sm:size-16 md:size-20 object-contain"
        />
        <span className='text-lg sm:text-xl md:text-2xl lg:text-3xl inline-flex gap-2 font-FigtreeBold text-ui_blue -mt-3 px-2 break-words'>
          {LandingPageContent.explanation.getStarted.title.map(item => (
            <p
              className={`${item.is_special ? 'font-FigtreeRegular' : ''} break-words`}
              id={item.is_special ? 'gradient-text-2' : ''}
              key={item.text}>
              {item.text}{' '}
            </p>
          ))}
        </span>
        <p className='text-xs sm:text-sm font-FigtreeSemiBold text-ui_blue text-center opacity-80 w-full md:w-[90%] -mt-3 px-2 break-words'>
          {LandingPageContent.explanation.getStarted.description}
        </p>
        <Button
          onClick={openModal}
          className='w-full py-2 sm:py-3'
          textClassName='!text-sm sm:!text-base md:!text-lg'
          title={LandingPageContent.explanation.getStarted.ctaText}
        />
      </div>
    </div>
  );
};